<template>
    <div class="interesting-slider">
        <DefSlider
            :nav="$store.state.global.screenWidth <= 992"
            :settings="settings"
            ref="slider"
        >
            <div
                v-for="item in result"
                :key="item.offer && item.offer.id || item.id"
                class="swiper-slide"
            >
                <SliderCard :result="item" />
            </div>
        </DefSlider>
    </div>
</template>

<script>
import DefSlider from "../../Def/DefSlider/DefSlider.vue";
import SliderCard from "../../card/SliderCard/SliderCard.vue";

export default {
    name: 'InterestingSlider',
  components: {SliderCard, DefSlider},
    selector: '.interesting-slider',
    props: ['result'],
    data() {
        return {
            settings: {
                slidesPerView: 2,
                spaceBetween: 0,
                autoplay: {
                    delay: 5000,
                },
                breakpoints: {
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 0,
                        autoplay: false,
                    },
                }
            },
        }
    },
}
</script>

<style lang="scss" scoped>
.interesting-slider{
    ::v-deep{
        .slider-card{
            @include point-lg{
                border-top: 1px solid #e0dbd5;
                border-right: 1px solid #e0dbd5;
                border-bottom: 1px solid #e0dbd5;
                height: 100%;
            }
        }
        @media (max-width: 992px) {
            .def-slider__next{
                right: 0;
            }
            .def-slider__prev{
                left: 0;
            }
        }
    }
}
</style>